import React from 'react';
import { Alert as AntAlert } from 'antd';
import styled, { css } from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';
import { fadeAnimationCss } from '../../styles/GlobalStyle';

type BannerType = 'success' | 'info' | 'warning' | 'error';
type CloseIconAlign = 'start' | 'center';

interface CustomStyles {
  width?: CSSSize | 0;
  background?: ColorHex;
  backgroundAlert?: ColorHex;
  iconColor?: ColorHex;
  border?: string;
  borderAlert?: React.CSSProperties['border'];
  boxShadow?: boolean;
}

interface BannerProps {
  showIcon?: boolean;
  message?: React.ReactNode;
  description?: React.ReactNode;
  type?: BannerType;
  closable?: boolean;
  closeIconAlign?: CloseIconAlign;
  onClose?: () => void;
  className?: string;
  customStyles?: CustomStyles;
}

function Banner({
  message,
  description,
  showIcon,
  type,
  closable,
  closeIconAlign,
  onClose,
  className,
  customStyles,
}: BannerProps): React.ReactElement {
  const antOnClose = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onClose && onClose();
  };

  return (
    <StyledBanner
      showIcon={showIcon}
      message={message}
      description={description}
      type={type}
      closable={closable}
      onClose={antOnClose}
      className={className}
      customstyles={customStyles}
      closeiconalign={closeIconAlign}
    />
  );
}

const StyledBanner = styled(AntAlert)<{
  customstyles?: CustomStyles;
  closeiconalign?: CloseIconAlign;
}>`
  & {
    ${fadeAnimationCss}
  }
  &.ant-alert {
    color: ${colorsPalette.gray600};
    ${props => props.customstyles?.width && `width: ${props.customstyles.width};`}
    background: ${props => props.customstyles?.backgroundAlert};
    border: ${props => props.customstyles?.borderAlert};
    box-shadow: ${props =>
      props.customstyles?.boxShadow ? '8px 6px 25px -2px rgba(34, 60, 80, 0.3)' : ''};
  }
  ${props =>
    props.closeiconalign === 'start' &&
    css`
      .ant-alert-close-icon {
        align-self: flex-start;
      }
    `}
  &.ant-alert-info {
    background: ${props => props.customstyles?.background || '#e6f4ff'};
    border: ${props => props.customstyles?.border || '1px solid #91caff'};

    .ant-alert-icon {
      color: ${props => props.customstyles?.iconColor || '#1677ff'};
    }
  }
`;

export default Banner;
export type { BannerType };
